<app-card-widget title="Client" subtitle="{{data.client?.name}}" *ngIf="clientAndRepresentative$ | async as data">

  <form [formGroup]="form" id="client-form" (ngSubmit)="save(data.client, data.representative)" novalidate>

    <div class="card-section-container">
      <div class="card-section" formGroupName="client">

        <app-text label="Client's Name">
            <a [routerLink]="['/light-entrepreneur-clients/', data.client.id]">{{data.client.name}}</a>
        </app-text>
        <app-text label="Personal ID">{{data.client.personal_id}}</app-text>

        <app-text label="Invoicing Co. Business ID" *ngIf="!edited">{{data.client.invoicing_service_company_business_id}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Invoicing Co. Business ID" formControlName="invoicing_service_company_business_id" />
        </mat-form-field>

      </div>
      <div class="card-section" formGroupName="representative">

        <app-text label="First Name" *ngIf="!edited">{{data.representative.first_name}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="First Name" formControlName="first_name" />
        </mat-form-field>

        <app-text label="Last Name" *ngIf="!edited">{{data.representative.last_name}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Last Name" formControlName="last_name" />
        </mat-form-field>

        <app-text label="SSN">{{data.representative.masked_ssn}}</app-text>

      </div>
      <div class="card-section" formGroupName="representative">
        <app-text label="Email" *ngIf="!edited">{{data.representative.email}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Email" type="email" formControlName="email" />
        </mat-form-field>

        <app-text label="Phone" *ngIf="!edited">{{data.representative.phone}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Phone" formControlName="phone" />
        </mat-form-field>

        <app-text label="Created" *ngIf="!edited">{{ data.client.created_at | date }}</app-text>
      </div>

    </div>

  </form>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!edited" [disabled]="locked" (click)="edit(data.client, data.representative)">Edit</button>
    <!--
      Save sends PUT /clients/{id} first, which needs clients:edit (issue
      #678), so it is gated as the company Client widget's Save is: the
      wrapper carries the tooltip.
    -->
    <ng-container *ngIf="edited">
      <ng-container *ngIf="{ allowed: canEditClient$ | async } as editGate">
        <span
          class="save-client-action"
          [matTooltip]="editGate.allowed === false ? editPermissionTooltip : ''"
          [matTooltipDisabled]="editGate.allowed !== false"
          [attr.tabindex]="editGate.allowed === false ? 0 : null">
          <button type="submit" mat-button [disabled]="!form.valid || editGate.allowed !== true" form="client-form">Save</button>
        </span>
      </ng-container>
    </ng-container>
    <button type="reset" mat-button *ngIf="edited" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>
